import React from 'react';
import { Heart, MoreVertical } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CarCardProps {
  id: number;
  image: string;
  year: string;
  make: string;
  model: string;
  trim: string;
  price: string;
  mileage: string;
  sold?: boolean;
}
export function CarCard({
  id,
  image,
  year,
  make,
  model,
  trim,
  price,
  mileage,
  sold = false
}: CarCardProps) {
  return <Link to={`/autos/${id}`} className={`group rounded-xl border-2 hover:shadow-lg transition-colors duration-200 cursor-pointer flex flex-col h-full relative ${sold ? 'bg-[#25281F] border-[#C9A24E]/35' : 'bg-[#2B2E27] border-[#C9A24E] hover:border-[#E3BE72]'}`} data-id="element-11" data-mp="1ct94thgqjcy4">
      {/* Image Section */}
      <div className="relative aspect-[4/3] w-full bg-[#1A1C17] rounded-t-[10px] overflow-hidden" data-id="element-12" data-mp="yrwsdg0s9tgz">
        <img src={image} alt={`${year} ${make} ${model}`} className={`w-full h-full object-cover transition-transform duration-500 ${sold ? 'opacity-60 saturate-50' : 'group-hover:scale-105'}`} data-id="element-13" data-mp="3ojbi98oplsxr" />

        {/* Sold Badge */}
        {sold && <div className="absolute top-3 left-3 px-3 py-1 rounded-full bg-[#1A1C17]/80 border border-[#C9A24E]/60 backdrop-blur-sm" data-id="element-14" data-mp="2g02zoq7dk9rl">
            <span className="text-[11px] font-medium tracking-[0.18em] text-[#C9A24E]" data-id="element-15" data-mp="21za3m11fd6md">
              VENDIDO
            </span>
          </div>}

        {/* Favorite Button */}
        {!sold && <button onClick={e => e.preventDefault()} aria-label="Guardar vehículo" className="absolute top-3 right-3 p-2 rounded-full bg-[#1A1C17]/70 hover:bg-[#1A1C17] text-[#F2F0E9] transition-colors shadow-sm backdrop-blur-sm" data-id="element-16" data-mp="1s8p7qld4yg75">
            <Heart className="w-5 h-5" strokeWidth={1.5} data-id="element-17" data-mp="1o96nlrt5295d" />
          </button>}
      </div>

      {/* More Options Button (overlapping bottom edge of image) */}
      {!sold && <div className="absolute right-4 top-[calc(75%-20px)] z-10" data-id="element-18" data-mp="1eah6w2czauqp">
          <button onClick={e => e.preventDefault()} aria-label="Más opciones" className="w-10 h-10 rounded-full bg-[#2B2E27] border-2 border-[#C9A24E] flex items-center justify-center text-[#F2F0E9] hover:border-[#E3BE72] transition-colors shadow-md" data-id="element-19" data-mp="v5c9w5et6x5s">
            <MoreVertical className="w-5 h-5" strokeWidth={1.5} data-id="element-20" data-mp="ggy8lyx1jgrc" />
          </button>
        </div>}

      {/* Content Section */}
      <div className="p-4 pt-5 flex flex-col flex-grow" data-id="element-21" data-mp="1e3f1mryqr87a">
        <h3 className={`text-[15px] mb-1 line-clamp-2 ${sold ? 'text-[#A8AA9E]' : 'text-[#F2F0E9]'}`} data-id="element-22" data-mp="195djqad1xexe">
          {year} {make} {model} {trim}
        </h3>

        <div className="mt-auto flex items-center gap-3" data-id="element-23" data-mp="148deu2rxui7v">
          <span className={`text-xl font-bold ${sold ? 'text-[#8C8F84]' : 'text-[#C9A24E]'}`} data-id="element-24" data-mp="z65zd37wgk0s">
            {price}
          </span>
          <span className="text-[#6E7368] font-light text-sm" data-id="element-25" data-mp="3jxesj1ap86sm">|</span>
          <span className={`text-[15px] font-bold ${sold ? 'text-[#8C8F84]' : 'text-[#C6C4B9]'}`} data-id="element-26" data-mp="3jw3or1h96z1i">
            {mileage}
          </span>
        </div>
      </div>
    </Link>;
}